import Vue from 'vue'
import App from './App.vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueCurrencyInput from 'vue-currency-input'
import Vuelidate from 'vuelidate';
import VTooltip from 'v-tooltip'
import VueI18n from 'vue-i18n'

// vue i18n
Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const i18n = new VueI18n({
  // eslint-disable-next-line no-undef
  locale: wpData.current_language,  
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
})

// Vuelidate
Vue.use(Vuelidate);
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: null,
    locale: i18n.locale,
    distractionFree: false,
    allowNegative: false,
    precision: 0,
    valueAsInteger: true,
  }
})

Vue.use(VTooltip);
VTooltip.options.defaultTrigger = 'hover , click';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

// vue custom directives and filters
Vue.directive('focus', {

  inserted: function (el, binding) {
    if (binding.value != "off")
      el.focus()
  }
})
Vue.filter('locale', function (value) {
  return value.toLocaleString(i18n.locale);
});

Vue.config.productionTip = false

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app')